import comingsoon from '../assets/coming-soon.svg'

export default function ComingSoon(props) {
    const setTitle = props.setTitle;
    const setProgress = props.setProgress;

    return (
        <div className="coming_soon">
            <img src={comingsoon} alt="Coming Soon" />
        </div>
    );
}